// src/auth/screens/SetPasswordScreen.jsx — route /set-password?token=…
//
// ⚠️ PATH IS BACKEND CONFIGURATION: `set_password_url` in
// context-library/product/transactional-email.yaml.
//
// ⚠️ Why this screen is part of the password-recovery issue: POST
// /auth/password-reset sends the SET-PASSWORD mail when the address belongs to
// a user who never onboarded ("One button, two mails" in
// <BACKEND_FOLDER>/docs/frontend/password-reset-flow.md). Without this route those users land
// on the catch-all redirect and recovery is broken for them.
import React from 'react';
import TokenPasswordScreen from './TokenPasswordScreen.jsx';

export default function SetPasswordScreen() {
  return <TokenPasswordScreen variant="set" />;
}
